// t('Required')
// t('Optional')
// t('Hidden')
export enum VariableDisplay {
    Required = 'Required',
    Optional = 'Optional',
    Hidden = 'Hidden',
}
